module.exports = __webpack_public_path__ + "static/media/sell_help_10c.d9e3475e.png";